export enum TYPES {
    DEFAULT = 'default',
    WARNING = 'warning',
    BLOCK = 'block',
}
